import { useRef } from 'react';
import { CenterSpinner } from '~/common/components/CenterSpinner';
import { EditComps } from '../../../Comparables/EditComps/EditComps';
import { ViewComps } from '../../../Comparables/ViewComps/ViewComps';
import { useListingPageContext } from '../ListingPageContext';

export const Comparables = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const geocoderInputRef = useRef<HTMLInputElement>(null);

  const {
    listing,
    comparableSet,
    comps,
    setComps,
    isViewOnly,
    propertyDetails,
  } = useListingPageContext();

  const onAdd = () => {
    geocoderInputRef.current?.focus();
  };

  if (!listing && !propertyDetails) {
    return <CenterSpinner />;
  }

  return isViewOnly ? (
    <ViewComps
      comparableSet={comparableSet}
      comps={comps}
      listing={listing}
      propertyDetails={propertyDetails}
    />
  ) : (
    <EditComps
      comparableSet={comparableSet}
      comps={comps}
      containerRef={containerRef}
      geocoderInputRef={geocoderInputRef}
      listing={listing}
      propertyDetails={propertyDetails}
      setComps={setComps}
      onAdd={onAdd}
    />
  );
};
